import { apiGet, apiPut } from '@jumbo/utils/ApiHelper';
import config from 'config';
import { moveLoadsToRequestsApi, bookLoadApi, bidLoadApi } from './loads';
const loadApiUrl = config.loadApiUrl;
const tripApiUrl = config.tripApiUrl;

export function getTripsNewRequestApi(data) {
  return apiGet(tripApiUrl, 'admin/trips/interests', data);
}

export function getTripsDetailsApi(tripId) {
  return apiGet(tripApiUrl, `admin/trips/interests/${tripId}`);
}
export function getLoadsBetweenTwoCitiesApi(data) {
  return apiGet(loadApiUrl, `admin/lanes/loads`, data);
}

export function updateLoadInTripInterestLaneMapping(tripId, data) {
  return apiPut(tripApiUrl, `admin/trips/interests/${tripId}`, data);
}

export function rejectTripInterest(tripId) {
  return apiGet(tripApiUrl, `admin/trips/interests/${tripId}/reject`);
}

export function bookBidRequestLoadApi(type, loadId, data) {
  if (type === 'book') {
    return bookLoadApi(loadId, data);
  } else if (type === 'bid') {
    return bidLoadApi(loadId, data);
  } else if (type === 'requests') {
    return moveLoadsToRequestsApi(loadId, data);
  }
}
